import { NFT, NFTCollection } from '@/constants/game-config';
import { appConfigAtom, appEventsAtom, gameDataAtom } from '@/state/app';
import { walletAtom } from '@/state/wallet';
import { getGame } from '@/utils/http/get-game';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

export const useWhitelist = () => {
    const walletState = useRecoilValue(walletAtom);
    const appEvents = useRecoilValue(appEventsAtom);
    const setAppConfig = useSetRecoilState(appConfigAtom);
    const setGameData = useSetRecoilState(gameDataAtom);

    // Checks whitelist for the duration of the session
    useEffect(() => {
        checkAccess().then();
    }, [walletState.selectedAddress, appEvents.gameMintEvent]);

    const checkAccess = async () => {
        if (walletState.selectedAddress) {
            // Check with the API if whitelisted
            const nfts = (await getGame({ address: walletState.selectedAddress })) as NFT[];
            const keys = Object.values(NFTCollection)
                .filter((nft) => nft.isKey)
                .map((x) => x.id);
            const isWhitelisted = keys.some((key) =>
                nfts
                    .filter((x) => x.balance && x.balance > 0)
                    .map((x) => x.id)
                    .includes(key),
            );
            setGameData((previous) => ({ ...previous, nfts }));
            // TODO restore whitelist once open
            setAppConfig((previous) => ({ ...previous, isWhitelisted: false }));
        }
    };
};
